import memberService from "../../services/MemberService";

export default class MessPopUpAction {
  static getLastMessShowAtLogin = async () => {
     const messageResult = await memberService.getLastMessShowAtLogin().then(res => {      
      if (res.status >= 400) {
        return [];
      }
      return res.data;
    }).catch(e =>{
      return [];
    });
    return messageResult;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/MessPopUpComponent/MessPopUpAction.js